import Isotope from "isotope-layout";
import resizeCards from './cards'
var i;
var filterWrapper = document.querySelector(".filter");
var checkboxes = document.querySelectorAll('input[type="checkbox"]');
var revealMore = document.querySelector(".reveal-more");

// Isotope filter
var isoGrid = document.querySelector('.iso--grid');

if (isoGrid) {
  var iso = new Isotope(isoGrid, {
    // options
    itemSelector: '.iso--item',
    layoutMode: 'fitRows'
  });
}

var checkboxes = document.querySelectorAll('input[type="checkbox"]');
let cardItem = document.querySelectorAll(".card--item:not(.card--item__quicklinks):not(.card--item__usp):not(.card--item__cta)");
var inclusives = [];
for (i = 0; i < checkboxes.length; i++) {
  checkboxes[i].addEventListener("change", function () {
    if (this.checked == true) {
      inclusives.push(this.value)
    } else {
      var self = this.value;

      var index = inclusives.indexOf(self);
      if (index > -1) {
        inclusives.splice(index, 1)
      }
    }

    var filterValue = inclusives.length ? inclusives.join(', ') : '*';

    if (iso) {
      iso.arrange({ filter: filterValue });
    }

    resizeCards(cardItem)
    if (revealMore) {
      revealMore.style.display = "none";
    }
  });
}

// Clear filters

var resetFilterToggle = document.querySelector(".clear-filter");
if (resetFilterToggle) {
  resetFilterToggle.addEventListener("click", function () {
    for (i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked = true) {
        checkboxes[i].checked = false;
      }
    }
    if (iso) {
      iso.arrange({ filter: '*' });
    }
  });
}

// Toggle filters Desktop

var filterToggle = document.querySelectorAll("aside .filter--toggle");
if (filterToggle) {
  for (i = 0; i < filterToggle.length; i++) {
    filterToggle[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
}


// Toggle filters mobile
var filterMobileToggle = document.querySelector(".filter--toggle__mobile");
var navOverlay = document.querySelector(".nav-overlay");
var closeBtn = document.querySelector(".btn-save");
if (filterMobileToggle) {
  var filterMobile = filterMobileToggle.nextElementSibling;

  filterMobileToggle.addEventListener('click', () => {
    filterMobile.classList.toggle("open");
    navOverlay.classList.toggle("open");
    document.querySelector('body').classList.add('n-o');
  })
}

if (closeBtn) {
  closeBtn.addEventListener('click', () => {
    var filterOpen = document.querySelector(".filter.open");
    if (filterOpen) {
      filterOpen.classList.remove('open');
      navOverlay.classList.remove("open");
      document.querySelector('body').classList.remove('n-o');
    }
  })
}

document.addEventListener('click', function (e) {
  if (e.target.closest('.filter') === null && e.target !== document.querySelector(".filter--toggle__mobile")) {
    var filterOpen = document.querySelector(".filter.open");
    if (filterOpen) {
      filterOpen.classList.remove('open');
      navOverlay.classList.remove("open");
      document.querySelector('body').classList.remove('n-o');
    }
  }
});





// WEBPACK FOOTER //
// ./scripts/components/filter.js